import React from 'react';
import { Wizard } from 'react-use-wizard';
import InfoDevForm from '../infoDevForm/infoDevForm';
import ConfirmacionDev from '../confirmacionDev/confirmacionDev';
import HeaderComponent from '../../../../components/header/header_component';
import cn from '../../../../lib/bem';

import './infoDevLayout.scss';

const InfoDevLayout = ({mostrarPolizaMensaje}) => {
  
  const classes = cn("infoDevLayout");

  return (
    <div className={classes()}>
      <HeaderComponent flagHeaderMobile={false} index={false} title={"Finalización de plazo de póliza"}/>
      <Wizard>
        <InfoDevForm 
          titulo="D&eacute;janos tu informaci&oacute;n"
          descripcion="Completa la informaci&oacute;n requerida para proceder con el dep&oacute;sito. Recuerda que t&uacute; debes ser el titular, la cuenta no debe ser mancomunada y estar en la moneda de tu p&oacute;liza."
          nombreMonto="Monto de finalizaci&oacute;n de p&oacute;liza"
        />
        <ConfirmacionDev 
          mostrarPolizaMensaje={mostrarPolizaMensaje}
          descripcion1="Completa la informaci&oacute;n requerida para iniciar con el proceso de dep&oacute;sito. Recuerda que t&uacute; debes ser el titular, la cuenta no debe ser mancomunada y estar en la moneda de tu p&oacute;liza."
          descripcion2="Te estaremos confirmando a trav&eacute;s de mensaje de texto al n&uacute;mero de celular registrado cuando se realice el abono."
          nombreMonto="Monto de finalizaci&oacute;n de p&oacute;liza"
          descInfo="Recuerde que si añade otra cuenta que no corresponde al titular de la póliza será rechazada."
          descripcion1Edit="Revisa la informaci&oacute;n requerida para poder iniciar con el rescate. Recuerda que t&uacute; debes ser el titular, la cuenta no debe ser mancomunada y estar en la moneda de tu p&oacute;liza."
          descripcion2Edit="Te estaremos confirmando a trav&eacute;s de mensaje de texto al n&uacute;mero de celular registrado cuando se realice el abono."
          nombreMontoEdit="Monto de finalizaci&oacute;n de p&oacute;liza"
          descInfoEdit="Esta cuenta quedará guardada sólo para este trámite."
          descripcionVerificacion="Escribe aqu&iacute; el c&oacute;digo de 6 d&iacute;gitos que te hemos enviado a trav&eacute;s de correo electr&oacute;nico o n&uacute;mero de celular."
        />
      </Wizard>
    </div>
  );
}



export default InfoDevLayout;

